module.exports = __webpack_public_path__ + "img/master-cut.a6c0c0d0.jpg";